
window.addEventListener('scroll', function(e) {

  const pageSection = document.querySelectorAll('.para-wrap');
  for(var i = 0; i < pageSection.length; i++) {
    let pageSectionSize = pageSection[i].getBoundingClientRect(),
        target = pageSection[i].querySelectorAll('.scroll'),
        index = 0, length = target.length;

    for (index; index < length; index++) {
      var pos = pageSectionSize.top * target[index].dataset.rate;

      if(target[index].dataset.direction === 'vertical') {
          target[index].style.transform = 'translate3d(0px,'+pos+'px, 0px)';
      }
    }
  }
});